import { render, staticRenderFns } from "./VmrLogo.vue?vue&type=template&id=78f8a6a2&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f8a6a2')) {
      api.createRecord('78f8a6a2', component.options)
    } else {
      api.reload('78f8a6a2', component.options)
    }
    module.hot.accept("./VmrLogo.vue?vue&type=template&id=78f8a6a2&", function () {
      api.rerender('78f8a6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/VmrLogo.vue"
export default component.exports